/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
/* eslint-disable no-void */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable object-curly-newline */
import React, { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import valueOf from "logic/valueOf";

export const viewTypes = {
    VIEW_TYPE_PAGE: "ページ",
    VIEW_TYPE_CASES: "件",
};

type ViewType = valueOf<typeof viewTypes>;

interface PaginationProps {
    viewType: ViewType;
    data: any[];
    viewCases: number; // 件数表示
    setViewData: React.Dispatch<React.SetStateAction<any[]>>;
}

const Pagination = (props: PaginationProps) => {
    const { viewType, data, viewCases, setViewData } = props;
    const allCases = data.length;

    // 表示開始位置（ページの場合はページ数、件の場合は表示する最初の配列番号）
    const [start, setStart] = useState<number>(0);

    useEffect(() => {
        // 親の表示stateへ表示データをセットする
        const _data = [...data];
        if (viewType === viewTypes.VIEW_TYPE_PAGE) {
            setViewData(_data.splice(start * viewCases, viewCases));
        } else {
            setViewData(_data.splice(start, viewCases));
        }
    }, [start, data]);

    // 左ボタン押下時
    const onClickLeft = () => {
        if (viewType === viewTypes.VIEW_TYPE_PAGE) {
            setStart(start - 1);
        } else {
            setStart(start - viewCases);
        }
    };

    // 右ボタン押下時
    const onClickRight = () => {
        if (viewType === viewTypes.VIEW_TYPE_PAGE) {
            setStart(start + 1);
        } else {
            setStart(start + viewCases);
        }
    };

    // 最大ページ数
    const maxPage = Math.floor(allCases / viewCases) + Number(allCases % viewCases > 0);
    // 表示している一番最後の配列番号
    const end = start + viewCases > allCases ? allCases : start + viewCases;

    // 中央の表示位置テキスト
    const text =
        viewType === viewTypes.VIEW_TYPE_CASES && viewCases
            ? `${start + 1}~${end}${viewTypes.VIEW_TYPE_CASES} / ${allCases}${viewTypes.VIEW_TYPE_CASES}`
            : `${start + 1}${viewTypes.VIEW_TYPE_PAGE} / ${maxPage}${viewTypes.VIEW_TYPE_PAGE}`;

    // 右ボタン操作可否
    const disabledRight = viewType === viewTypes.VIEW_TYPE_CASES && viewCases ? start + viewCases >= allCases : start === allCases;

    return (
        <Grid item xs={12} container direction="row" alignItems="center" justifyContent="space-between">
            <Grid item>
                <Button size="small" disabled={start === 0} onClick={onClickLeft} sx={{ color: "inherit" }}>
                    <KeyboardArrowLeftIcon />
                </Button>
            </Grid>
            <Grid item>
                <Typography>{text}</Typography>
            </Grid>
            <Grid item>
                <Button size="small" disabled={disabledRight} onClick={onClickRight} sx={{ color: "inherit" }}>
                    <KeyboardArrowRightIcon />
                </Button>
            </Grid>
        </Grid>
    );
};

export default Pagination;
